
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.219 15v-.383c.26-.052.453-.11.578-.172a.639.639 0 00.289-.258.945.945 0 00.094-.453c0-.177-.021-.367-.063-.57a7.271 7.271 0 00-.18-.695l-.289-1.008h-3.64l-.266.766a7.683 7.683 0 00-.265.875 2.638 2.638 0 00-.063.539c0 .312.078.541.234.687.162.146.407.242.735.29V15H.047v-.383c.292-.047.544-.216.758-.508.218-.291.43-.708.632-1.25l3.258-8.648H5.93l2.656 8.71c.125.407.234.717.328.93.099.214.216.38.352.5.135.12.32.209.554.266V15H6.22zm-3-4.219h3.265L5 5.742l-1.781 5.04zm2.054-6.906c-.562 0-.992-.13-1.289-.39-.291-.261-.437-.644-.437-1.15 0-.343.075-.634.226-.874a1.38 1.38 0 01.641-.54c.27-.119.578-.179.922-.179.573 0 1.008.13 1.305.39.296.261.445.639.445 1.134 0 .515-.159.914-.477 1.195-.312.276-.757.414-1.336.414zm-.906-1.594c0 .35.08.623.242.82.162.193.404.29.727.29.302 0 .531-.092.687-.274.162-.182.243-.437.243-.765 0-.365-.086-.644-.258-.836-.167-.193-.396-.29-.688-.29-.312 0-.55.092-.71.274-.162.182-.243.443-.243.781z","fill":"currentColor"}})])
          )
        }
      }
    